module.exports = __webpack_public_path__ + "img/domestic-2016-new-books.c7e014d7.jpg";